<template>
<div>NavigationTask</div>
</template>

<script>
export default {
  name: 'NavigationTask'
}
</script>

<style scoped>

</style>
